/**
 * SCRUM-722: the pages slice lives in ./pagesSlice.ts (createSlice +
 * createAsyncThunk). This module re-binds the slice's public creators under
 * the legacy import path so the ~26 existing importers — components and the
 * jest.mock/jest.spyOn call-sites — keep working unchanged. The re-binds are
 * deliberate `export const` assignments (not `export ... from`) so the
 * CommonJS interop keeps the properties writable for jest.spyOn. New code
 * should import from './pagesSlice'.
 *
 * Dropped legacy exports (no importer anywhere, verified during SCRUM-722):
 * updatePage, updateRequiredPage, and getSubCategoriesbyId (the app uses
 * categoryAction's getSubCategoriesbyIds instead).
 */
import {
  getPagesByCurrentSite as _getPagesByCurrentSite,
  addPage as _addPage,
  addRequiredPage as _addRequiredPage,
  updatePageContent as _updatePageContent,
  deletePage as _deletePage,
  selectedFilters as _selectedFilters,
  getPageById as _getPageById,
  clearPage as _clearPage,
} from "./pagesSlice";

export const getPagesByCurrentSite = _getPagesByCurrentSite;
export const addPage = _addPage;
export const addRequiredPage = _addRequiredPage;
export const updatePageContent = _updatePageContent;
export const deletePage = _deletePage;
export const selectedFilters = _selectedFilters;
export const getPageById = _getPageById;
export const clearPage = _clearPage;
